import React, { useState } from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  RestPageListBean,
  RestReadRequest,
  SKUBatchInventoryTrackSearchCriteria,
  FabricStyleSearchCriteria,
  RestFabricStyleListBeanRequest,
  RestSKUBatchInventoryTrackListRequest,
  SKUBatchInventorySearchCriteria,
  RestSkuBatchInventoryListRequest,
} from "../ds/ds.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupFabricStyleModule,
  PopupInventoryAdjustmentModule,
  PopupInventoryTransferModule,
  PopupInvoiceModule,
  PopupLogisticReceiptModule,
  PopupPickTicketModule,
  PopupPurchaseReceiptModule,
  PopupCustomerModule,
} from "../modules/ModuleUtil.js";
import { ReportService } from "../services/ReportService.js";
import {
  AlertToolBox,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition,
  InputCheckbox,
  NumberFormatInputbox,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import CustomTable from "../gui_components/CustomTable.js";
import { InventoryService } from "../services/InventoryService.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
class RollingInventoryReportDetails extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Rolling Inventory  Report Details  Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new SKUBatchInventoryTrackSearchCriteria(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMessage: "",
      success_list: [],
      moduleForPopup: [],
      warehouses: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isDisableFields: false,
      isCollapsible_open: true,
      services: [],
      serviceLookupHandler: null,
      servicePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteServiceList: false,
      isShowFabricStyleModule: false,
      isShowInventoryAdjustmentModule: false,
      isShowPurchaseReceiptModule: false,
      isShowInvoiceModule: false,
      isShowPickticketModule: false,
      isShowInventoryTransferModule: false,
      isShowLogisticReceiptModule: false,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      customerLookupHandler: null,
      isShowServiceLookup: false,
      totalAmount: 0,
      totalQty: 0,
      fabricLookupHandler: null,
      changeQtyList: [],
      isShowChangeQtyPopup: false,
      totalNumberOfQuantity: 0,
      isShowAlert1: false,
    };
    this.fabricCodeRef = React.createRef();
    this.customerCodeRef = React.createRef();
    this.serviceCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    let warehouses = attribute_cache.warehouses;
    if (warehouses != null || warehouses != undefined) {
      warehouses.map((attr) => {
        this.state.warehouses.push(attr);
      });
    }

    let services = attribute_cache.serviceInfos;
    if (services != null || services != undefined) {
      services.map((attr) => {
        this.state.services.push(attr);
      });
    }
    this.initLookupHandlers();
  }
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      if (!this.state.isShowChangeQtyPopup) {
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
          // if (!isShowChangeQtyPopup){
          //   isShowAlert: true,
          // } else {
          //   isShowAlert: true,
          // }
        });
      } else {
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert1: true,
        });
      }
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  validate = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (isEmptyString(data.fabricStyleCode)) {
      let errMsg = "Item Code is Required";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
        isLoading: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    } else {
      isValid = true;
      this.setState({ isShowAlert: false });
    }
    return isValid;
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    // criteria.fetchQuantityAvailableLinesOnly = true;
    let isValid = false;
    isValid = this.validate(criteria);
    if (isValid) {
      this.loadRollingInventoryReportDetailsInquiryList(criteria);
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Executing...",
      });
    }
  };
  loadRollingInventoryReportDetailsInquiryList = (criteria) => {
    if (SecurityAccessManager.SkuBatchInventoryInquiry_IsAccessible()) {
      ReportService.inquireRollingInventories(
        criteria,
        this.loadRollingInventoryReportPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadRollingInventoryReportPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.resultBean != null) {
      let customerSalesDataList = [];
      let inquiryDataList = response.data.resultBean;
      if (!isEmptyArray(response.data.resultBean.infos)) {
        customerSalesDataList = response.data.resultBean.infos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: customerSalesDataList,
        isCollapsible_open: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        inquiryData: inquiryDataList,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateSalesServiceReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    // pageInput.pageSize = 20;
    // pageInput.currentPage = 1;
    let listRequest = new RestSKUBatchInventoryTrackListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.RollingInventoryReportDetailsInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateRollingInventoriesDetailsPrintReport(
          listRequest,
          this.generateSkuBatchInventoryPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.RollingInventoryReportDetailsInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateRollingInventoriesDetailsPrintReport(
          listRequest,
          this.generateSkuBatchInventoryPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateSkuBatchInventoryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new SKUBatchInventoryTrackSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = "";
    criteria.fabricStyleName = "";

    this.setState({
      criteria: criteria,
      isDisableFields: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isCollapsible_open: true,
      isShowServiceLookup: false,
      services: [],
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new SKUBatchInventoryTrackSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = "";
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowColorLookup: false,
      isShowResetButton: false,

      isDisableFields: false,
      isShowClearCriteriaButton: true,
      isCollapsible_open: true,
      totalPages: 0,
      isShowServiceLookup: false,
      services: [],
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateSalesServiceReport(1);
  };
  generateExcel = () => {
    this.generateSalesServiceReport(2);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowInventoryAdjustmentModule: isOpen,
      isShowPurchaseReceiptModule: isOpen,
      isShowInvoiceModule: isOpen,
      isShowPickticketModule: isOpen,
      isShowInventoryTransferModule: isOpen,
      isShowLogisticReceiptModule: isOpen,
      moduleForPopup: [],
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowChangeQtyPopup: isShowPopup,
    });
    this.hideAlertCallBack();
  };

  onModuleExit = () => {
    this.props.onModuleExit();
  };

  showHideSecondHeader = (e) => {
    if (e.detail === 1) {
      let isCollapsible_open = !this.state.isCollapsible_open;
      this.setState({ isCollapsible_open: isCollapsible_open });
    }
  };

  viewFabricModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (rowData.entityType === "FabricStyleInventoryAdjustment") {
        if (code !== "" && code !== undefined) {
          this.setState({
            isShowInventoryAdjustmentModule: true,
            moduleForPopup: (
              <PopupInventoryAdjustmentModule
                code={code}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      } else if (rowData.entityType === "PurchaseOrderReceipt") {
        if (code !== "" && code !== undefined) {
          this.setState({
            isShowPurchaseReceiptModule: true,
            moduleForPopup: (
              <PopupPurchaseReceiptModule
                code={code}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      } else if (rowData.entityType === "Invoice") {
        if (code !== "" && code !== undefined) {
          this.setState({
            isShowInvoiceModule: true,
            moduleForPopup: (
              <PopupInvoiceModule
                invoiceCode={code}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      } else if (rowData.entityType === "PickTicket") {
        if (code !== "" && code !== undefined) {
          this.setState({
            isShowPickticketModule: true,
            moduleForPopup: (
              <PopupPickTicketModule
                pickTicketCode={code}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      } else if (rowData.entityType === "InventoryTransferLocation") {
        if (code !== "" && code !== undefined) {
          this.setState({
            isShowInventoryTransferModule: true,
            moduleForPopup: (
              <PopupInventoryTransferModule
                code={code}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      } else if (rowData.entityType === "LogisticOrderReceipt") {
        if (code !== "" && code !== undefined) {
          this.setState({
            isShowLogisticReceiptModule: true,
            moduleForPopup: (
              <PopupLogisticReceiptModule
                code={code}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      }
    }
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item#" : "FabricStyle#",
          "itemCode",
          true
        )

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")

        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ContainerNumber", "containerNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("Price", "price", true)
    //     .setStyleDetails("right", "", "", "wt-2", "wt-2")

    // );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("Price", "price", true)
    //     .setStyleDetails("right", "", "", "wt-2", "wt-2")

    // );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "", true)
        .setStyleDetails("center", "", "", "", "")
        .setSpanDetails(false, true, 3)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OpenQty", "startQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setSpanDetails(true)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ChangeQty", "changeQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewChangeQty, null)
        .setSpanDetails(true)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CloseQty", "endQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setSpanDetails(true)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Process", "entityCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
        .setClickDetails(false, false, this.viewModule, null)
        .setSpecialDetails(true, "entityType")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "date", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );

    return columns;
  };
  readFabricStyleResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      criteria.fabricStylesCode = fabricStyle.code;
      this.setState({ fabricStyleData: fabricStyle });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readFabricStyle = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readFabricStyleResponse,
      this.errorCallBack
    );
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        criteria: criteria,
        fabricPageListForAutoCompleteList: suggestion,
        // isShowColorLookup: false,
        // colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readandsetFabricStyleDetail(fabricStyleCode);
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteFabricList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteFabricList });
  };
  viewChangeQty = (e, val, rowData) => {
    if (e.detail === 1) {
      let tempData = { ...rowData };
      let criteria = new SKUBatchInventorySearchCriteria();
      criteria.companyCode = this.companyCode;
      criteria.updateEntityCode = tempData.entityCode;
      criteria.updateEntityType = tempData.entityType;
      criteria.fabricStyleCode = tempData.itemCode;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 500;
      pageInput.currentPage = 1;
      let listRequest = new RestSkuBatchInventoryListRequest();
      listRequest.searchCriteria = criteria;
      listRequest.pageInput = pageInput;

      this.loadSkuBatchInventoryInquiryList(listRequest);
    }
  };
  loadSkuBatchInventoryInquiryList = (listRequest) => {
    if (
      SecurityAccessManager.RollingInventoryReportDetailsInquiry_IsAccessible()
    ) {
      InventoryService.getSkuBatchInventoryPageList(
        listRequest,
        this.loadSkuBatchInventoryPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };

  loadSkuBatchInventoryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.skuBatchInventoryPageList != null
    ) {
      let resultList = [];
      let totalNumberOfQuantity = 0;
      let totalQty = 0;
      if (
        !isEmptyArray(
          response.data.skuBatchInventoryPageList.skuBatchInventories
        )
      ) {
        resultList =
          response.data.skuBatchInventoryPageList.skuBatchInventories;
        totalNumberOfQuantity = resultList.reduce((acc, curr) => {
          return acc + curr.onHandQuantity || 0;
        }, 0);
      }
      resultList.map((line) => {});
      resultList.map((line) => {
        totalQty = line.onHandQuantity + totalQty;
      });
      this.setState({
        changeQtyList: resultList,
        isShowChangeQtyPopup: true,
        totalNumberOfQuantity: totalNumberOfQuantity,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  lineColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item" : "FabricStyle#",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "ItemName" : "FabricStyleName",
          "fabricStyleName",
          true
        )
        .setStyleDetails("left", "10", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "3", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Container#", "containerNumber", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Roll#", "rollNumber", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Inventory#" : "RollSkuNumber#",
          "rollSkuNumber",
          true
        )
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sku", "skuNumber", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "SERIAL#" : "Vendor Lot",
          "vendorBatchNumber",
          true
        )
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "onHandQuantity", true, true)
        .setStyleDetails("right", "2", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("WHPO#", "warehousePurchaseOrderNumber", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("IMEI#", "imeiNumber", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Ref", "customerReferenceNumber", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2")
    );

    return columns;
  };
  render() {
    const inquiryDataList = this.state.inquiryDataList;
    const inquiryData = this.state.inquiryData;
    let changeQtyList = this.state.changeQtyList;
    let totalNumberOfQuantity = this.state.totalNumberOfQuantity;

    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          {...this.state}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          onModuleExit={this.onModuleExit}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
        />

        <div>
          {this.state.isInquiryDatasFound && (
            <div className="mt-3">
              <CustomTable
                data={inquiryDataList}
                columns={this.inquiryColumns()}
                isEnableSpan={true}
                label={"Inquiry Data List"}
              />
            </div>
          )}
        </div>

        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowChangeQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel2"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Line Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>Total OnHandQty</FormLabel>
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={totalNumberOfQuantity}
                    className="summary_input text-right"
                    decimalScale={2}
                    name={"totalNumberOfQuantity"}
                    disabled={true}
                  />
                </Col>
              </Row>

              <div className="mt-3">
                <CustomTable
                  data={changeQtyList}
                  columns={this.lineColumns()}
                />
              </div>
            </div>
          }
        />

        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInventoryAdjustmentModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPickticketModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowLogisticReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInventoryTransferModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const onChange = (e) => props.onChange(e);
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  let criteria = props.criteria;
  let fabricLookupHandler = props.fabricLookupHandler;
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = (e) => {
    props.displayAutoCompleteFabricList(e);
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>FabricStyle</FormLabel>
          )}
        </Col>
        <Col sm="2">
          <InputTextbox
            showCriteriaDialog={true}
            // ref={fabricCodeRef}
            name="fabricStyleCode"
            onChange={fabricCodeOnChange}
            value={criteria.fabricStyleCode}
            lookupRequired={true}
            lookupHandler={fabricLookupHandler}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            name="fabricStyleName"
            onChange={onChange}
            value={criteria.fabricStyleName}
            disabled={true}
          />
        </Col>
        <Col sm="2">
          <FormLabel> ExcludeNonWarehouseInventory </FormLabel>
        </Col>

        <Col sm="1">
          <InputCheckbox
            name="isExcludeNonWarehouseInventory"
            checked={criteria.isExcludeNonWarehouseInventory}
            onChange={onChange}
            disabled={props.isDisableFields}
          />
        </Col>
      </Row>
    </div>
  );
}

function RollingInventoryReportInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <RollingInventoryReportDetails {...props} name="" /> <br />
    </div>
  );
}

export default RollingInventoryReportInquiry;
